import type {Monitoring} from '../../types'
import {findIndex, filter, propEq, assoc} from 'ramda'

const initialState: Monitoring = {
  portfolios: [],
  selectedPortfolio: 0,
  portfoliosLoader: false,
  portfoliosError: '',
  loader: false,
  error: '',
  companies: [],
  resTime: 0,
  totalSize: 0,
  company: {
    events: [],
    loader: false,
    error: null,
  },
  pageNo: 1,
  pageSize: 10,
  pageRange: 5,
}

const defaultPortfolio = (list) => {
  let portfolios = filter(propEq('isDefault', true), list)
  return portfolios.length > 0 ? portfolios[0].portfolioId : (list.length > 0 ? list[0].portfolioId : 0)
}

const accessPortfolios = (data) => {
  let list = [...data.sharedPortfolios]
  let sharedPortfolios = list.map((p, index) => {
    let item = assoc('isShared', true, p)
    return item
  })
  return data.portfolios.concat(sharedPortfolios)
}

export default (state: Monitoring = initialState, action): Monitoring => {
  const {type, payload, data} = action
  switch (type) {
    case 'GET_PORTFOLIOS':
      return {
        ...state,
        portfoliosLoader: true,
        selectedPortfolio: 0,
      }
    case 'GET_PORTFOLIOS_SUCCESS':
      return {
        ...state,
        portfoliosLoader: false,
        portfolios: accessPortfolios(payload.data) || [],
        selectedPortfolio: defaultPortfolio(payload.data.portfolios),
        portfoliosError: '',
      }
    case 'GET_PORTFOLIOS_FAILURE':
      return {
        ...state,
        portfoliosLoader: false,
        portfolios: [],
        portfoliosError: payload.data,
      }
    case 'CHANGE_PORTFOLIO':
      return {
        ...state,
        selectedPortfolio: data,
      }
    case 'MONITORING_RESULT_PAGE_CHANGE':
      return {
        ...state,
        pageNo: data,
      }
    case 'GET_COMPANIES':
      return {
        ...state,
        loader: true,
      }
    case 'GET_COMPANIES_SUCCESS':
      return {
        ...state,
        loader: false,
        companies: payload.data,
        totalSize: payload.totalCount,
        resTime: payload.responseTime,
        error: '',
      }
    case 'GET_COMPANIES_FAILURE':
      return {
        ...state,
        loader: false,
        error: payload.data,
        companies: [],
        resTime: payload.responseTime,
        totalSize: 0,
        pageNo: 1,
      }
    case 'DELETE_PORTFOLIO_SUCCESS':
      let portfoliosList = state.portfolios
      const index = findIndex(propEq('portfolioId', data), portfoliosList)
      portfoliosList.splice(index, 1)
      return {
        ...state,
        portfolios: portfoliosList,
        selectedPortfolio: portfoliosList.length > 0 ? portfoliosList[0].portfolioId : 0,
      }
    case 'CREATE_PORTFOLIO_SUCCESS':
      const list = state.portfolios
      list.push(payload)
      return {
        ...state,
        portfolios: list,
      }
    case 'GET_EVENTS':
      return {
        ...state,
        company: {
          ...state.company,
          loader: true,
          events: [],
        },
      }
    case 'GET_EVENTS_SUCCESS':
      return {
        ...state,
        company: {
          ...state.company,
          loader: false,
          events: payload.data,
          error: null,
        },
      }
    case 'GET_EVENTS_FAILURE':
      return {
        ...state,
        company: {
          ...state.company,
          loader: false,
          error: payload.data,
        },
      }
    case 'LOG_OUT':
      return initialState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/monitoring/reducer.js